//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.Coatings.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/SelectTaggedObjectList.js";
import "../GeometricUtilities/GeometricUtilities.ProjectionOptions.js";
import "../Features/Features.Coatings.RegionListItemBuilderList.js";
import "../no/ScCollector.js";
import "../no/Features.js";
import "../no/ScCollector.js";
import "../no/SelectObjectList.js";
import "../no/ObjectList.js";
let d=[[[1,"BoundaryObject",0,"SelectTaggedObjectList",0],[0,"DistanceTolerance",1,0],[0,"ImprintBothSide",1,0],[0,"IsHideBoundaryObjects",1,0],[1,"ProjectionDirection",0,"GeometricUtilities.ProjectionOptions",0],[1,"RegionList",0,"Features.Coatings.RegionListItemBuilderList",0],[1,"TargetFace",0,"ScCollector",0]],[[[],"CreateRegionListItem",{R_:{regionListItemBuilder:"Features.Coatings.RegionListItemBuilder"}},0,0],[["nRegionPoints"],"GetSelectedRegionPoints",{R_:{regionPoints:"Point[]"}},0,0],[["regionPoints"],"SetSelectedRegionPoints",{},1,0],[["regionPoint","regionBoundaries"],"InsertPointBoundaryMap",{},2,0],[["regionPoint"],"ErasePointBoundaryMap",{},1,0],[["regionPoint","regionLaminarEdges"],"InsertPointLaminarMap",{},2,0],[["regionPoint"],"ErasePointLaminarMap",{},1,0]],[]];
SPLM.Features.Coatings.CoatingRegionBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.Coatings.CoatingRegionBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;